"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEpointageSites = void 0;
class GetEpointageSites {
    constructor(epointageRepository) {
        this.epointageRepository = epointageRepository;
    }
    execute(request) {
        return this.epointageRepository.getEpointageSites(request);
    }
}
exports.GetEpointageSites = GetEpointageSites;
